angular.module('unica_auth.auth_controllers')

.controller('LoginController', function(
	$rootScope, $scope, $state, $interval, $sce,
	LoginService ) {

	// $scope.checkUserAuth({});


	$scope.mfaStep = false;
	$scope.mfaSetupStep = false;
	$scope.mfaSetupData = {};
	$scope.loading = false;
	$scope.loginData = {};
	$scope.doLogin = function() {
		$scope.loading = true;
		$scope.showLoader();

		if (!$scope.mfaStep && !$scope.mfaSetupStep) {
			// Primo step: credenziali
			LoginService.login($scope.loginData)
				.then(function(data) {
					console.log(data);
					$scope.hideLoader();
					$scope.loading = false;
					if (!data) return;

					if (data.mfa_setup_required) {
						$scope.mfaSetupStep = true;
						$scope.loginData.user_id = data.user_id;
						$scope.loginData.password = undefined;
						// Chiedi secret/QR
						LoginService.mfaSetup({user_id: data.user_id})
							.then(function(setup) {
								$scope.mfaSetupData = setup;
								$scope.mfaSetupData.qr_svg = $sce.trustAsHtml($scope.mfaSetupData.qr_svg);
							});
						return;
					}
					if (data.mfa_required) {
						$scope.mfaStep = true;
						$scope.loginData.user_id = data.user_id; // per step 2
						$scope.loginData.password = undefined; // sicurezza
						return;
					}
					// Login diretto se non serve MFA
					$scope.showSuccessMsg('Login effettuato con successo!', '');
					$rootScope.setCurrentUser(data);
					$rootScope.isAuthorized = true;
					$state.go('app.dashboard');
				});
		} else if ($scope.mfaStep) {
			// Secondo step: verifica TOTP
			LoginService.verifyTotp($scope.loginData)
				.then(function(data) {
					$scope.hideLoader();
					$scope.loading = false;
					if (!data) return;
					$scope.showSuccessMsg('Login effettuato con successo!', '');
					$rootScope.setCurrentUser(data);
					$rootScope.isAuthorized = true;
					$state.go('app.dashboard');
				});
		}
	};

	// Step onboarding: conferma MFA
	$scope.doMfaSetup = function() {
		$scope.loading = true;
		$scope.showLoader();
		LoginService.activateMfa({
			user_id: $scope.loginData.user_id,
			totp: $scope.loginData.totp
		}).then(function(data) {
			$scope.hideLoader();
			$scope.loading = false;
			if (!data) return;
			$scope.showSuccessMsg('Login effettuato con successo!', '');
			$rootScope.setCurrentUser(data);
			$rootScope.isAuthorized = true;
			$state.go('app.dashboard');
		});
	};

});